export const defaultCss = `
/* Font Family */
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap");

body {
  font-family: "Poppins", sans-serif;
  background-color: #fafafa;
}

input[type="range"] {
  width: 100%;
  height: 6px;
  -webkit-appearance: none;
  appearance: none;
  border-radius: 5px;
  border: 1px solid #ccc;
  background: #262626;
}

input[type="range"]::-webkit-slider-thumb {
  width: 10px;
  -webkit-appearance: none;
  appearance: none;
  height: 10px;
  cursor: pointer;
  background: #080808;
  border-radius: 10px;
}

.rewards-page-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* ACCOUNT SECTION  */
.accountSection-wrapper {
  margin: 100px 0 50px 0;
  text-align: center;
}
.customer-greeting-container,
.customer-details-container {
  margin-bottom: 20px;
}
.customer-points-details {
  padding-bottom: 10px;
  font-weight: 500;
}
.customer-vip-tier-details {
  padding-top: 10px;
  font-weight: 500;
}
.customer-buttons-container {
  padding: 20px;
}
.customer-primary-button {
  background-color: #000000;
  border: 2px solid #000000;
  color: #fafafa;
  padding: 15px;
  min-width: 200px;
  margin-right: 10px;
  cursor: pointer;
  text-transform: uppercase;
  font-weight: 600;
}
.customer-secondary-button {
  background-color: #ffffff;
  color: #000000;
}

/* YOUR ACTIVITY SECTION */
.youractivity-wrapper {
  margin: -30px 0 10px 0;
  width: 100%;
}
.youractivity-heading {
  font-size: 30px;
  font-weight: 600;
  color: #000;
  text-align: center;
}
.youractivity-items-wrapper {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 20px;
}
.youractivity-no-items-text {
  text-align: center;
}

.youractivity-item-container,
.freeProductCatetory-item-container {
  min-width: 270px;
  padding: 10px 20px;
  margin: 5px;
  background: #ccc;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  border-radius: 10px;
  border: 1px dashed #ffffff;
}
.youractivity-item-details-container,
.freeProductCatetory-item-details-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.youractivity-item-primary-text,
.freeProductCatetory-item-primary-text {
  margin-bottom: 2px;
}
.youractivity-item-secondary-text,
.freeProductCatetory-item-secondary-text {
  font-size: 12px;
}
.youractivity-item-date {
  font-size: 12px;
  margin-left: auto;
}

/* VIP TIERS SECTION  */
.vipTiers-section-wrapper {
  width: 100%;
  margin: 20px 0;
}
.vipTiers-heading-container {
  width: 100%;
  margin-bottom: 20px;
}
.vipTiers-heading {
  font-size: 30px;
  font-weight: 600;
  color: #000;
  text-align: center;
}
.vipTiers-items-warpper {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  flex-wrap: wrap;
}

/* vip tier item  */
.vipTiers-item-container {
  width: 48%;
  background-color: #e0e0e0;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  margin-bottom: 10px;
}
.vipTiers-icon-title-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 15px 20px;
  background-color: #cccccc;
  border-bottom: 1px solid #fafafa;
}
.vipTiers-icon-container {
  width: 50px;
  height: 50px;
  padding: 2px;
  display: flex;
  align-items: center;
  margin-right: 20px;
  border: 1px solid #fafafa;
  border-radius: 10px;
  overflow: hidden;
}
.vipTiers-icon-container > img {
  width: 100%;
  height: 100%;
  border-radius: 10px;
}
.vipTiers-title-container h3 {
  font-weight: 600;
  font-size: 22px;
}
.vipTiers-rules-container {
  padding: 20px;
}
.vipTiers-rules-text,
.vipTiers-rewards-text {
  font-weight: 500;
  font-size: 18px;
}
.vipTiers-rules-items {
  margin: 10px 0;
}
.vipTiers-rules-item-text {
  font-size: 14px;
}
.vipTiers-rewards-container {
  padding: 20px;
  background-color: #cccccc;
  border-top: 1px solid #fafafa;
}
.vipTiers-rewards-item-container {
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.vipTiers-rewards-item-icon-container {
  display: flex;
  align-items: center;
}
.vipTiers-rewards-item-icon {
  margin-right: 20px;
}
.vipTiers-rewards-item-details-container {
  text-align: left;
}
.vipTiers-rewards-item-text {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 4px;
}
.vipTiers-rewards-item-subtext {
  font-size: 14px;
}

.vipTiers-current-tier-text-container {
  position: absolute;
  top: 0;
  right: 0;
  padding: 10px 20px;
}
.vipTiers-current-tier-text {
  font-size: 14px;
  font-weight: 500;
}

.vipTiers-benefits-container {
  padding: 20px;
  border-top: 1px solid #fafafa;
}
.vipTiers-benefits-item {
  font-size: 14px;
  margin: 8px 0;
}
.vipTiers-benefits-text {
  font-weight: 500;
  font-size: 18px;
  margin-bottom: 10px;
}

/* MEMBERSHIP PROGRAM SECTION  */
.membershipProgram-section-wrapper {
  width: 100%;
  margin: 20px 0;
}
.membershipProgram-heading-container {
  width: 100%;
  margin-bottom: 20px;
}
.membershipProgram-heading {
  font-size: 30px;
  font-weight: 600;
  color: #000;
  text-align: center;
  margin-bottom: 20px;
}
.membershipProgram-desc {
  font-size: 16px;
  color: #7b8794;;
  text-align: center;
  margin-bottom: 4px;
}
.membershipProgram-note {
  font-size: 12px;
  color: #7b8794;;
  text-align: center;
  margin-bottom: 4px;
}
.membershipProgram-name {
  font-size: 20px;
  font-weight: 500;
  color: #000;
  text-align: center;
}
.membershipProgram-items-wrapper {
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
}
.membershipProgram-noPlan {
  font-size: 16px;
  color: #7b8794;;
  text-align: center;
}

/* MEMBERSHIP PLAN */
.membershipProgram-item-container {
  width: 48%;
  background-color: #e0e0e0;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  margin-bottom: 10px;
}
.membershipProgram-active-plan-text-container {
  position: absolute;
  top: 0;
  right: 0;
  padding: 5px 10px;
  background-color: #262626;
  color: #fff;
  border-radius: 6px;
  font-size: 14px;
}
.membershipProgram-active-plan-text {
  font-size: 14px;
  font-weight: 500;
}
.membershipProgram-icon-title-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 15px 20px;
  background-color: #cccccc;
  border-bottom: 1px solid #fafafa;
}
.membershipProgram-icon-container {
  width: 60px;
  height: 60px;
  padding: 2px;
  display: flex;
  align-items: center;
  margin-right: 20px;
  border: 1px solid #fafafa;
  overflow: hidden;
}
.membershipProgram-icon-container > img {
  width: 100%;
  height: 100%;
}
.membershipProgram-title-container h3 {
  font-weight: 600;
  font-size: 22px;
}
.membershipProgram-benefits-container {
  width: 100%;
}
.membershipProgram-benefits-text {
  padding-top: 20px;
  padding-left: 20px;
  font-weight: 500;
  font-size: 18px;
}
.membershipProgram-noBenefit {
  font-size: 16px;
  color: #7b8794;
  text-align: center;
  padding-top: 20px;
  padding-left: 20px;
}
.membershipProgram-benefits-item-container {
  display: flex;
  margin-left: 12px;
  margin-right: 12px;
  padding-top: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #CBD5E0;
}
.membershipProgram-benefits-item-img {
  width: 40px;
  height: 40px;
  margin-right: 12px;
  padding: 4px;
}
.membershipProgram-benefits-item-title-desc-container {
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
}
.membershipProgram-benefits-item-title-desc-container h3 {
  text-align: left;
  font-weight: 500;
  font-size: 16px;
}
.membershipProgram-benefits-item-title-desc-container p {
  color: #777474;
  text-align: left;
  font-size: 14px;
}
.membershipProgram-benefits-coupon-item-container {
  display: flex;
  flex-direction: column;
  margin-left: 12px;
  margin-right: 12px;
  padding-top: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #CBD5E0;
}
.membershipProgram-benefits-coupon-item-img-title-container {
  display: flex;
}
.membershipProgram-benefits-coupon-item-couponCode-container {
  width: 100%;
  align-self: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.membershipProgram-benefits-coupon-item-couponCode-desc {
  padding-left: 12px;
  margin-bottom: 12px;
  margin-top: 20px;
  font-size: 14px;
  color: #777474;
}
.membershipProgram-benefits-coupon-item-couponCode-input-btn-container {
  width: 50%;
  color: #a0aec0;
  position: relative;
  font-size: 14px;
  margin-bottom: 16px;
  padding: 0 12px;
}
.membershipProgram-benefits-coupon-item-couponCode-input {
  background-color: #f7fafc;
  -webkit-user-select: all;
  -moz-user-select: all;
  -ms-user-select: all;
  user-select: all;
  width: 100%;
  border-radius: 10px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border: 1px solid #e6e6e6;
  font-size: 14px;
  margin: 0;
  outline: none;
  padding: 12px 20px;
  padding-right: 44px;
}
.membershipProgram-benefits-coupon-item-couponCode-input-btn {
  border-radius: 7px;
  position: absolute;
  right: 16px;
  top: 6px;
  background-color: transparent;
  border: none;
  border-radius: 3px;
  color: inherit;
  cursor: pointer;
  font-weight: inherit;
  line-height: inherit;
  font: inherit;
  height: 36px;
  padding: 8px;
  text-align: left;
  width: 36px;
}
.membershipProgram-benefits-coupon-item-couponCode-input-btn::after {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20'%3E%3Cpath fill='%238d8d8f' fill-rule='nonzero' d='M2.75 18.25H14a.75.75 0 1 1 0 1.5H2a.75.75 0 0 1-.75-.75V5a.75.75 0 0 1 1.5 0v13.25zM6 .25h12a.75.75 0 0 1 .75.75v14a.75.75 0 0 1-.75.75H6a.75.75 0 0 1-.75-.75V1A.75.75 0 0 1 6 .25zm.75 1.5v12.5h10.5V1.75H6.75z'/%3E%3C/svg%3E");
  background-position: 50%;
  background-repeat: no-repeat;
  bottom: 0;
  content: "";
  left: 0;
  opacity: 0.6;
  position: absolute;
  right: 0;
  top: 0;
  transition: background-color 0.15s ease-in-out, opacity 0.15s ease-in-out;
}
.membershipProgram-benefits-coupon-item-couponCode-btn-container {
  margin-bottom: 8px;
  padding: 0 12px;
  width: 50%;
}
.membershipProgram-benefits-coupon-item-couponCode-btn {
  width: 100%;
  cursor: pointer;
  border-radius: 10px;
  padding: 10px 16px;
  background-color: #262626;
  color: #fff;
  font-size: 14px;
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.membershipProgram-benefits-additional-item-container {
  display: flex;
  align-items: center;
  margin-left: 12px;
  margin-right: 12px;
  padding-top: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #CBD5E0;
}
.membershipProgram-benefits-additional-item-title-container h3 {
  text-align: left;
  font-weight: 500;
  font-size: 16px;
}

/* LIMITED TIME OFFER SECTION  */
.limitedTimeOfferProgram-section-wrapper {
  width: 100%;
  margin: 20px 0;
  display: flex;
  flex-direction: column;
}
.limitedTimeOfferProgram-heading-container {
  width: 100%;
  margin-bottom: 20px;
}
.limitedTimeOfferProgram-heading {
  font-size: 30px;
  font-weight: 600;
  color: #000;
  text-align: center;
  margin-bottom: 20px;
}
.limitedTimeOfferProgram-desc {
  font-size: 16px;
  color: #7b8794;;
  text-align: center;
  margin-bottom: 10px;
}
.limitedTimeOfferProgram-items-wrapper {
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
}
.limitedTimeOffer-item-container {
  align-self: center;
  width: 48%;
  background-color: #e0e0e0;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  margin-bottom: 10px;
}
.limitedTimeOffer-icon-title-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 15px;
  background-color: #cccccc;
  border-bottom: 1px solid #fafafa;
}
.limitedTimeOffer-icon-container {
  width: 40px;
  height: 40px;
  margin-right: 15px;
}
.limitedTimeOffer-icon-container > img {
  width: 100%;
  height: 100%;
}
.limitedTimeOffer-title-container h3 {
  font-size: 18px;
  font-weight: 600;
  color: #000;
}
.limitedTimeOffer-rewards-container {
  width: 100%;
  padding: 15px 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
}
.limitedTimeOffer-rewards-container p {
  text-align: left;
  font-weight: 500;
  font-size: 16px;
}
.limitedTimeOffer-rewards-container span {
  color: #777474;
  text-align: left;
  font-size: 14px;
}

/* REWARDS SECTION  */
.rewards-section-wrapper {
  width: 100%;
  margin: 20px 0;
}
.rewards-heading-container {
  width: 100%;
  margin-bottom: 20px;
}
.rewards-heading {
  font-size: 30px;
  font-weight: 600;
  color: #000;
  text-align: center;
}
.rewards-items-warpper {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
}
.rewards-item-container {
  min-width: 200px;
  padding: 10px 20px;
  margin: 10px;
  background: #ccc;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  border-radius: 10px;
  border: 1px dashed #ffffff;
}
.rewards-item-container:hover {
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  border: 1px dashed #000;
}
.rewards-item-icon-container {
  display: flex;
  align-items: center;
  margin-right: 15px;
}
.rewards-item-details-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.rewards-item-primary-text {
  margin-bottom: 2px;
}
.rewards-item-secondary-text {
  font-size: 12px;
}
.rewards-discount-giftcard-wrapper {
  padding: 20px 10px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.rewards-back-button-warpper {
  padding: 10px 20px;
}
.rewards-back-button {
  padding: 5px 20px;
  font-size: 14px;
  background: none;
  border: none;
  outline: none;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.rewards-back-button-icon {
  margin-right: 10px;
}
.rewards-no-rewards-container {
  padding: 10px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.rewards-no-rewards-icon {
  margin-right: 10px;
}
.rewards-no-rewards-text {
  font-size: 14px;
}
.rewards-detailview-button-container {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.rewards-detailview-button {
  padding: 5px 20px;
  font-size: 14px;
  background: none;
  border: none;
  outline: none;
  display: flex;
  align-items: center;
  cursor: pointer;
}
/* discount item  */
.discountItem-wrapper {
  width: 400px;
  background-color: #e0e0e0;
  box-shadow: 0 0 15px -10px rgb(0 0 0 / 75%);
  border-radius: 10px;
  padding: 16px 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
.discountItem-primary-container {
  width: 100%;
  margin-bottom: 12px;
  padding: 10px 15px 10px 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 10px;
  animation: fadeIn 0.5s ease-in;
}
.discountItem-primary-image-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}
.discountItem-primary-text-container {
  text-align: left;
}
.discountItem-primary-text {
  margin-bottom: 4px;
  font-size: 14px;
}
.discountItem-primary-subtext {
  font-size: 12px;
}
.discountItem-secondary-container {
  width: 100%;
  padding-left: 12px;
  margin-bottom: 20px;
  font-size: 14px;
  color: #565656;
}
.discountItem-secondary-text {
  margin-bottom: 5px;
  font-size: 14px;
}
.discountItem-secondary-subtext {
  font-size: 12px;
}
.discountItem-code-container {
  width: 100%;
  margin-bottom: 16px;
  position: relative;
  font-size: 14px;
  margin-bottom: 20px;
  padding: 0 12px;
}
.discountItem-code-container > input {
  user-select: all;
  width: 100%;
  border-radius: 10px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border: 1px solid #e6e6e6;
  font-size: 14px;
  margin: 0;
  outline: none;
  padding: 15px 44px 15px 20px;
  font-size: 15px;
  color: #262626;
  cursor: pointer;
}
.discountItem-copy-btn {
  border-radius: 7px;
  position: absolute;
  right: 16px;
  top: 8px;
  background-color: transparent;
  border: none;
  border-radius: 3px;
  color: inherit;
  cursor: pointer;
  font-weight: inherit;
  line-height: inherit;
  font: inherit;
  height: 36px;
  padding: 8px;
  text-align: left;
  width: 36px;
}
.discountItem-copy-btn:after {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20'%3E%3Cpath fill='%238d8d8f' fill-rule='nonzero' d='M2.75 18.25H14a.75.75 0 1 1 0 1.5H2a.75.75 0 0 1-.75-.75V5a.75.75 0 0 1 1.5 0v13.25zM6 .25h12a.75.75 0 0 1 .75.75v14a.75.75 0 0 1-.75.75H6a.75.75 0 0 1-.75-.75V1A.75.75 0 0 1 6 .25zm.75 1.5v12.5h10.5V1.75H6.75z'/%3E%3C/svg%3E");
  background-position: 50%;
  background-repeat: no-repeat;
  bottom: 0;
  content: "";
  left: 0;
  opacity: 0.6;
  position: absolute;
  right: 0;
  top: 0;
  transition: background-color 0.15s ease-in-out, opacity 0.15s ease-in-out;
}
.discountItem-apply-button-container {
  margin-bottom: 8px;
  padding: 0 12px;
  width: 100%;
}
.discountItem-apply-button {
  width: 100%;
  background-color: rgb(34, 34, 34);
  color: rgb(255, 255, 255);
  border-radius: 10px;
  border: none;
  padding: 10px 16px;
  font-size: 16px;
  outline: none;
  cursor: pointer;
}
/* giftcard item  */
.giftcard-container {
  background: linear-gradient(135.19deg, rgb(38, 38, 38), rgb(0, 0, 0));
  color: rgb(255, 255, 255);
  -webkit-box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);
  border-radius: 10px;
  padding: 16px 12px;
  margin-bottom: 12px;
  height: 200px;
  transition: 0.5s;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;
  width: 340px;
  animation: fadeIn 0.5s ease-in;
  cursor: pointer;
}
.giftcard-copy-button-container {
  margin-bottom: 8px;
  padding: 0 12px;
  display: none;
  opacity: 0.3;
  transition: opacity 0.5s;
  width: 100%;
  animation: fadeIn 0.3s ease-in;
}
.giftcard-copy-button {
  border-radius: 10px;
  padding: 6px 0;
  background-color: #f5f5f5;
  font-size: 14px;
  width: 100%;
  outline: none;
  border: none;
  z-index: 99;
  cursor: pointer;
}

.giftcard-container:hover > .giftcard-copy-button-container {
  display: block;
  opacity: 1;
}

.giftcard-text {
  margin-top: 12px;
  padding: 5px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.giftcard-text > h1 {
  font-size: 46px;
  margin-top: 5px;
  font-weight: 500;
}
.faCirle-1 {
  color: rgb(255, 255, 255);
  font-size: 12px;
  position: absolute;
  top: 0px;
  left: 0px;
  margin: 10px 20px;
  opacity: 0.7;
}
.faCirle-2 {
  color: rgb(255, 255, 255);
  position: absolute;
  bottom: 0px;
  left: 0px;
  font-size: 150px;
  margin: -70px;
  opacity: 0.2;
}
.faCirle-3 {
  color: rgb(255, 255, 255);
  font-size: 10px;
  position: absolute;
  bottom: 50px;
  right: 0px;
  margin: 30px 50px 30px 30px;
  opacity: 0.3;
}
.faCirle-4 {
  color: rgb(255, 255, 255);
  font-size: 12px;
  position: absolute;
  top: 0px;
  left: 0px;
  margin: 10px;
  opacity: 0.7;
}
.faCirle-5 {
  color: rgb(255, 255, 255);
  font-size: 100px;
  position: absolute;
  top: 0px;
  right: 0px;
  margin: -30px;
  opacity: 0.2;
}
.giCirle-1 {
  color: rgb(255, 255, 255);
  font-size: 10px;
  position: absolute;
  top: 0px;
  right: 50px;
  margin: 20px 30px 0px 0px;
  opacity: 0.3;
}

/* WAYS TO EARN SECTION  */
.waysToEarn-section-wrapper {
  width: 100%;
  margin: 20px 0;
}
.waysToEarn-heading-container {
  width: 100%;
  margin-bottom: 20px;
}
.waysToEarn-heading {
  font-size: 30px;
  font-weight: 600;
  color: #000;
  text-align: center;
}
.waysToEarn-items-warpper {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
}
.waysToEarn-item-container {
  background: #dbdbdb;
  flex: 0 0 30%;
  min-width: 350px;
  margin: 10px;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  border: 1px dashed #ffffff;
}
.waysToEarn-item-container:hover {
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  border: 1px dashed #000;
}
.waysToEarn-item-image-container {
  width: 100%;
  height: 80px;
  margin-top: 20px;
}
.waysToEarn-item-image-container > img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.waysToEarn-item-text-container {
  width: 100%;
  padding: 10px 0 20px 0;
}
.waysToEarn-item-text {
  font-size: 16px;
  font-weight: 600;
  color: #000;
  text-align: center;
}
.waysToEarn-item-details-container {
  width: 100%;
  padding: 10px 15px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: #000;
  min-height: 47px;
}
.waysToEarn-item-details {
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
  text-transform: capitalize;
}
.waysToEarn-item-button {
  background: #fafafa;
  border: none;
  color: #000;
  padding: 10px 30px;
  font-size: 12px;
  border-radius: 10px;
  font-weight: 600;
  text-transform: uppercase;
  cursor: pointer;
}
.waysToEarn-item-button:disabled {
  opacity: 0.7;
}
.birthdayItem-detail-page-wrapper,
.redeemPointsGiftacrdItem-detail-page-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.birthdayItem-input-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}
.birthdayItem-input-text,
.redeemPointsGiftacrdItem-input-text {
  margin-bottom: 10px;
}
.birthdayItem-input {
  border-radius: 10px;
  padding: 10px 16px;
  background-image: none;
  border: 1px solid #dbdbdb;
  cursor: pointer;
  display: inline-block;
  font-family: inherit;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  touch-action: manipulation;
  transition: background-color 0.1s ease-in;
  user-select: none;
  vertical-align: middle;
  white-space: nowrap;
  outline: none;
}
.birthdayItem-save-btn-container,
.redeemPointsGiftacrdItem-redeem-btn-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.birthdayItem-save-btn,
.redeemPointsGiftacrdItem-redeem-btn {
  color: #fafafa;
  border: none;
  background-color: #000;
  padding: 15px 30px;
  font-size: 10px;
  border-radius: 10px;
  font-weight: 600;
  text-transform: uppercase;
  cursor: pointer;
}

.redeemPointsGiftacrdItem-redeem-btn:disabled {
  opacity: 0.8;
  cursor: not-allowed;
}

/* WAYS TO REDEEM SECTION  */
.waysToRedeem-section-wrapper {
  width: 100%;
  margin: 20px 0;
}
.waysToRedeem-heading-container {
  width: 100%;
  margin-bottom: 20px;
}
.waysToRedeem-heading {
  font-size: 30px;
  font-weight: 600;
  color: #000;
  text-align: center;
}
.waysToRedeem-items-warpper {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
}
.waysToRedeem-item-container {
  min-width: 350px;
  background: #dbdbdb;
  flex: 0 0 30%;
  margin: 10px;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  border: 1px dashed #ffffff;
  position: relative;
}
.waysToRedeem-item-container:hover {
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  border: 1px dashed #000;
}

.waysToRedeem-item-image-container {
  width: 100%;
  height: 80px;
  margin-top: 20px;
}
.waysToRedeem-item-image-container > img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.waysToRedeem-item-text-container {
  width: 100%;
  padding: 10px 0 20px 0;
}
.waysToRedeem-item-text {
  font-size: 16px;
  font-weight: 600;
  color: #000;
  text-align: center;
}
.waysToRedeem-item-details-container {
  width: 100%;
  padding: 10px 15px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: #000;
}
.waysToRedeem-item-details {
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
  text-transform: capitalize;
}
.waysToRedeem-item-button {
  background: #fafafa;
  border: none;
  color: #000;
  padding: 10px 30px;
  font-size: 12px;
  border-radius: 10px;
  font-weight: 600;
  text-transform: uppercase;
  cursor: pointer;
}
.waysToRedeem-item-button:disabled {
  opacity: 0.7;
}
.redeemPointsGiftacrdItem-detail-page-wrapper {
  padding: 20px;
}
.redeemPointsGiftacrdItem-input-wrapper {
  width: 80%;
  margin: 10px;
}
.redeemPointsGiftacrdItem-details-text {
  margin-bottom: 10px;
}
.redeemPointsGiftacrdItem-redeem-btn-container {
  margin: 10px 0;
}
/* FREE PRODUCT  */
.freeProduct-category-name {
  padding: 10px 40px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.freeProduct-category-back-icon {
  cursor: pointer;
}
.freeProduct-category-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
}
.freeProductCatetory-item-btn {
  margin-left: auto;
}
.freeProductCatetory-item-btn > button {
  background: #000;
  border: none;
  color: #ffffff;
  padding: 10px 20px;
  font-size: 14px;
  border-radius: 10px;
  cursor: pointer;
}
.freeproduct-item-container {
  min-width: 350px;
  max-height: 500px;
  background: #dbdbdb;
  flex: 0 0 30%;
  margin: 10px;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  border: 1px dashed #ffffff;
  position: relative;
}
.freeproduct-item-img {
  width: 88%;
}
.freeproduct-item-img > img {
  height: 86%;
  width: 100%;
  object-fit: cover;
}
.freeproduct-item-details-container {
  margin-top: -6px;
  padding: 10px;
  height: 14%;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.freeproduct-item-details {
  width: 60%;
}
.freeproduct-item-details-text {
  font-size: 14px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  /* width: 210px; */
  margin-bottom: 2px;
}
.freeproduct-item-details-subtext {
  font-size: 12px;
  color: rgb(63, 63, 63);
}
.freeproduct-item-button {
  background: #000;
  border: none;
  color: #ffffff;
  padding: 10px 20px;
  font-size: 14px;
  border-radius: 10px;
  cursor: pointer;
}

/* JOIN NOW SECTION  */
.joinNow-sec-wrapper {
  width: 100%;
}
.joinNow-background-container {
  width: 100%;
  min-height: 400px;
  background-image: url("https://super-rewards-images.s3.ap-south-1.amazonaws.com/general/banner.jpg");
  /* background: pink; */
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.joinNow-sec-content {
  /* background: rgba(0, 0, 0, 0.1); */
  width: 768px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.joinNow-text-container,
.joinNow-buttons-sec {
  width: 100%;
  text-align: center;
}
.joinNow-buttons-sec {
  margin: 60px 0 20px 0px;
}
.joinNow-primary-text {
  color: #ffffff;
  font-size: 44px;
  margin-bottom: 20px;
  text-shadow: 0px 0px 10px rgba(0, 0, 0, 0.8);
  text-transform: uppercase;
}
.joinNow-secondary-text {
  color: #ffffff;
  font-size: 20px;
  text-shadow: 0px 0px 10px rgba(0, 0, 0, 0.8);
}

.joinNow-button {
  width: 160px;
  height: 50px;
  margin: 1vw;
  cursor: pointer;
  font-size: 1.1rem;
  font-weight: 700;
  letter-spacing: 0.07rem;
  position: relative;
  overflow: hidden;
  transition: all 0.4s ease 0.1s;
  background-color: #000000;
  color: #ffffff;
  border: 2px solid #ffffff;
  border-radius: 10px;
  z-index: 1;
  transition: color 0.4s ease-in-out, border 0.4s ease-in-out 0.2s;
}

.joinNow-button:hover {
  color: #000000;
  border: 2px solid #000000;
}

.joinNow-button::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  height: 0%;
  width: 100%;
  background-color: #ffffff;
  transition: all 0.4s ease;
  z-index: -1;
}

.joinNow-button:hover::after {
  height: 100%;
}
.joinNow-already-info-text {
  color: #ffffff;
  font-size: 16px;
  margin-top: 20px;
  text-shadow: 0px 0px 10px rgba(0, 0, 0, 0.8);
}
.joinNow-signIn-link {
  color: #ffffff;
}

/* Refer Your Friend */
.referfriend-wrapper {
  background: #000000;
  width: 100%;
  min-height: 400px;
  margin-top: 50px;
  display: flex;
  flex-direction: row;
  color: #ffffff;
}
.referfriend-container-left,
.referfriend-container-right {
  width: 50%;
}
.referfriend-container-left {
  background-image: url("https://super-rewards-images.s3.ap-south-1.amazonaws.com/general/referral-side-image.jpg");
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  vertical-align: top;
  display: flex;
  align-items: center;
  justify-content: center;
}
.referfriend-heading-container {
  width: 100%;
}
.referfriend-heading {
  text-align: center;
  text-transform: uppercase;
  color: #ffffff;
  font-size: 50px;
  text-shadow: 2px 2px rgba(0, 0, 0, 0.8);
}
.referfriend-container-right {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.referfriend-details-container {
  width: 80%;
  text-align: center;
  margin-bottom: 40px;
}

.referfriend-details-heading {
  font-size: 32px;
  margin-bottom: 10px;
  word-spacing: 8px;
}
.referfriend-details-subheading {
  font-size: 16px;
}

.refer-sharing-warpper {
  width: 100%;
  border-top: 2px dashed #fafafa;
}

.referral-link-container {
  padding: 40px 40px 10px 40px;
  display: flex;
  flex-direction: row;
}
.referral-link-input {
  width: 100%;
  border: none;
  height: 50px;
  padding: 0 10px;
  font-size: 18px;
  font-family: "Courier New", Courier, monospace;
  border: 1px solid #fafafa;
  border-radius: 10px 0 0 10px;
  outline: none;
  cursor: pointer;
}
.referral-link-copy-btn {
  width: 50px;
  border: 1px solid #fafafa;
  border-radius: 0 10px 10px 0;
  cursor: pointer;
}
.referral-link-copy-icon {
  fill: #606568;
  height: 100%;
}
.referral-link-input:hover,
.referral-link-input:hover ~ .referral-link-copy-btn,
.referral-link-copy-btn:hover,
.refer-sharing-item-btn:hover {
  opacity: 0.9;
}

.refer-sharing-option-wrapper {
  padding: 20px 10px 0 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
}
.refer-sharing-item {
  height: 70px;
  width: 70px;
}
.refer-sharing-item-btn {
  width: 100%;
  height: 100%;
  padding: 5px;
  background: transparent;
  color: #fafafa;
  border: none;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: space-around;
  cursor: pointer;
}
.refer-sharing-item-btn-icon-container {
  width: 100%;
  height: 50%;
}
.refer-sharing-item-btn-icon {
  fill: #fafafa;
  width: 100%;
  height: 100%;
}

@media screen and (max-width: 999px) {
  /* Join Now section  */

  .joinNow-background-container {
    padding: 20px 0;
    width: 100%;
    min-height: 300px;
  }
  .joinNow-sec-content {
    width: 70%;
  }
  .joinNow-primary-text {
    font-size: 40px;
    margin-bottom: 20px;
  }
  .joinNow-secondary-text {
    font-size: 18px;
  }
}
@media screen and (max-width: 768px) {
  /* Join Now section  */
  .joinNow-primary-text {
    font-size: 32px;
    margin-bottom: 20px;
  }
  .joinNow-secondary-text {
    font-size: 18px;
  }

  .joinNow-button {
    font-size: 18px;
  }

  /* ways to earn  */
  .waysToEarn-item-container {
    flex: 0 0 30%;
    min-width: 300px;
    margin: 10px;
  }

  .waysToEarn-item-image-container {
    height: 60px;
    margin-top: 20px;
  }
  .waysToEarn-item-text {
    font-size: 14px;
  }
  .waysToEarn-item-details-container {
    padding: 10px 15px;
  }
  .waysToEarn-item-details {
    font-size: 12px;
  }
  .waysToEarn-item-button {
    padding: 8px 25px;
    font-size: 10px;
  }
  /* ways to redeem  */
  .waysToRedeem-item-container {
    flex: 0 0 30%;
    min-width: 300px;
    margin: 10px;
  }

  .waysToRedeem-item-image-container {
    height: 60px;
    margin-top: 20px;
  }
  .waysToRedeem-item-text {
    font-size: 14px;
  }
  .waysToRedeem-item-details-container {
    padding: 10px 15px;
  }
  .waysToRedeem-item-details {
    font-size: 12px;
  }
  .waysToRedeem-item-button {
    padding: 8px 25px;
    font-size: 10px;
  }

  /* Refer Your Friend */
  .referfriend-wrapper {
    flex-direction: column;
    margin-top: 30px;
  }
  .referfriend-container-left,
  .referfriend-container-right {
    width: 100%;
    min-height: 400px;
  }
  .referfriend-container-right {
    padding: 10px 0;
  }
  /* VIP TIERS  */
  .vipTiers-items-warpper {
    flex-direction: column;
    padding: 10px;
  }

  /* vip tier item  */
  .vipTiers-item-container {
    width: 100%;
    margin-bottom: 10px;
  }

  /* MEMBERSHIP PROGRAM */
  .membershipProgram-items-wrapper {
    flex-direction: column;
    padding: 10px;
  }

  /* MEMBERSHIP PLAN */
  .membershipProgram-item-container {
    width: 100%;
  }

  /* LIMITED TIME OFFER */
  .limitedTimeOfferProgram-items-wrapper {
    flex-direction: column;
    padding: 10px;
  }
  .limitedTimeOffer-item-container {
    width: 100%;
  }
}
@media screen and (max-width: 640px) {
  /* Join Now section  */
  .joinNow-background-container {
    min-height: 250px;
  }
  .joinNow-buttons-sec {
    margin: 40px 15px 0px;
  }
  .joinNow-primary-text {
    font-size: 28px;
    margin-bottom: 20px;
  }
  .joinNow-secondary-text {
    font-size: 16px;
  }
  .joinNow-button {
    width: 140px;
    height: 40px;
    font-size: 1rem;
  }

  /* ways to earn  */
  .waysToEarn-item-container {
    min-width: 240px;
    margin: 5px;
  }

  .waysToEarn-item-image-container {
    height: 50px;
    margin-top: 20px;
  }
  .waysToEarn-item-text {
    font-size: 12px;
  }
  .waysToEarn-item-details-container {
    padding: 9px 13px;
  }
  .waysToEarn-item-details {
    font-size: 10px;
  }
  .waysToEarn-item-button {
    padding: 8px 20px;
    font-size: 9px;
  }
  /* ways to redeem  */
  .waysToRedeem-item-container {
    min-width: 240px;
    margin: 5px;
  }

  .waysToRedeem-item-image-container {
    height: 50px;
    margin-top: 20px;
  }
  .waysToRedeem-item-text {
    font-size: 12px;
  }
  .waysToRedeem-item-details-container {
    padding: 9px 13px;
  }
  .waysToRedeem-item-details {
    font-size: 10px;
  }
  .waysToRedeem-item-button {
    padding: 8px 20px;
    font-size: 9px;
  }
}
@media screen and (max-width: 500px) {
  /* Join Now section  */

  .joinNow-sec-content {
    width: 90%;
  }

  .joinNow-buttons-sec {
    margin: 40px 0 20px 0px;
  }
  .joinNow-primary-text {
    font-size: 28px;
    margin-bottom: 10px;
  }
  .joinNow-secondary-text {
    font-size: 14px;
  }

  .joinNow-button {
    font-size: 16px;
  }
  .joinNow-already-info-text {
    font-size: 14px;
    margin-top: 20px;
  }
  /* ways to earn  */
  .waysToEarn-item-container {
    min-width: 200px;
    margin: 5px;
  }

  .waysToEarn-item-image-container {
    height: 40px;
    margin-top: 15px;
  }
  .waysToEarn-item-text-container {
    width: 100%;
    padding: 5px 0 12px 0;
  }
  .waysToEarn-item-text {
    font-size: 12px;
  }
  .waysToEarn-item-details-container {
    padding: 8px 10px;
  }
  .waysToEarn-item-details {
    font-size: 8px;
  }
  .waysToEarn-item-button {
    padding: 8px 18px;
    font-size: 8px;
  }

  /* ways to redeem  */
  .waysToRedeem-item-container {
    min-width: 200px;
    margin: 5px;
  }

  .waysToRedeem-item-image-container {
    height: 40px;
    margin-top: 15px;
  }
  .waysToRedeem-item-text-container {
    width: 100%;
    padding: 5px 0 12px 0;
  }
  .waysToRedeem-item-text {
    font-size: 12px;
  }
  .waysToRedeem-item-details-container {
    padding: 8px 10px;
  }
  .waysToRedeem-item-details {
    font-size: 8px;
  }
  .waysToRedeem-item-button {
    padding: 8px 18px;
    font-size: 8px;
  }

  /* refer friend  */
  .referfriend-heading {
    font-size: 32px;
  }
  .referfriend-details-heading {
    font-size: 24px;
  }
  .referfriend-details-subheading {
    font-size: 14px;
  }
}

@media screen and (max-width: 425px) {
  .joinNow-sec-content {
    width: 95%;
  }

  .joinNow-buttons-sec {
    margin: 30px 0 20px 0px;
  }
  .joinNow-primary-text {
    font-size: 22px;
  }
  .joinNow-secondary-text {
    font-size: 12px;
  }
  .joinNow-button {
    font-size: 14px;
  }
  .joinNow-already-info-text {
    font-size: 12px;
    margin-top: 15px;
  }
  /* ways to earn  */
  .waysToEarn-items-warpper {
    padding: 0 10px;
  }
  .waysToEarn-item-container {
    min-width: 100%;
    margin: 5px;
  }

  /* ways to redeem  */
  .waysToRedeem-items-warpper {
    padding: 0 10px;
  }
  .waysToRedeem-item-container {
    min-width: 100%;
    margin: 5px;
  }

  /* FREE PRODUCT  */
  .freeproduct-item-container {
    min-width: 100%;
  }
  /* rewards section  */
  .rewards-item-container,
  .youractivity-item-container,
  .freeProductCatetory-item-container {
    width: 100%;
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.loading-ring {
  display: inline-block;
  width: 25px;
  height: 10px;
}
.loading-ring:after {
  content: " ";
  display: block;
  width: 12px;
  height: 12px;
  margin-left: 8px;
  border-radius: 50%;
  border: 1px solid rgb(0, 0, 0);
  border-color: rgb(0, 0, 0) transparent rgb(0, 0, 0) transparent;
  animation: loading-ring 0.4s linear infinite;
}
@keyframes loading-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.rewards-page-loading-wrapper {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.rewards-page-loading {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.rewards-page-loading div {
  position: absolute;
  border: 4px solid rgb(0, 0, 0);
  opacity: 1;
  border-radius: 50%;
  animation: rewards-page-loading 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}
.rewards-page-loading div:nth-child(2) {
  animation-delay: -0.5s;
}
@keyframes rewards-page-loading {
  0% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: 0px;
    left: 0px;
    width: 72px;
    height: 72px;
    opacity: 0;
  }
}

`;
